import { createClient } from '@supabase/supabase-js';

// Absolute fallbacks for the project
const FALLBACK_URL = 'https://bjelydvroavsqczejpgd.supabase.co';
const FALLBACK_KEY = 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6ImJqZWx5ZHZyb2F2c3FjemVqcGdkIiwicm9sZSI6ImFub24iLCJpYXQiOjE3NTEwMjE2MDcsImV4cCI6MjA2NjU5NzYwN30.f-693IO1d0TCBQRiWcSTvjCT8I7bb0t9Op_gvD5LeIE';

const getEnv = (key, fallback) => {
  const val = import.meta.env[key];
  // If the env var is missing, malformed (contains spaces), or too short, use fallback
  if (!val || typeof val !== 'string' || val.trim().length < 10 || val.includes(' ')) {
    return fallback;
  }
  return val.trim();
};

const supabaseUrl = getEnv('VITE_SUPABASE_URL', FALLBACK_URL);
const supabaseAnonKey = getEnv('VITE_SUPABASE_ANON_KEY', FALLBACK_KEY);

export const supabase = createClient(supabaseUrl, supabaseAnonKey, {
  auth: {
    persistSession: true,
    autoRefreshToken: true
  }
});